import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';
import Box from '@mui/material/Box';
import HelpCard from '../../../components/common/HelpCard';
import SuccessPopup from '../../../components/common/SuccessPopup';
import {useRenewalClick} from '../context/RenewalClickContext';
import {handleContactClick} from '../api/renewalClickApi';

/**
 * Renewal Click's help card, wired to the shared contact-clicked backend flow.
 * Phone requests a callback (Salesforce notification to the renewal team) and
 * shows a success popup. WhatsApp is available from the header.
 */
const RenewalHelpCard = ({title, description, sx}) => {
  const intl = useIntl();
  const m = (id) => intl.formatMessage({id});
  const {opportunityId, currentScreen} = useRenewalClick();
  const [showSuccess, setShowSuccess] = useState(false);

  const onPhone = async () => {
    if (!opportunityId) return;
    const success = await handleContactClick(opportunityId, currentScreen, 'phone');
    if (success) setShowSuccess(true);
  };

  return (
    <>
      <Box sx={sx}>
        <HelpCard
          title={title}
          description={description}
          callLabel={m('renewalClick.helpCall')}
          onCall={onPhone}
        />
      </Box>
      <SuccessPopup
        open={showSuccess}
        onClose={() => setShowSuccess(false)}
        title={m('renewalClick.contactSuccess.title')}
        description={m('renewalClick.contactSuccess.description')}
      />
    </>
  );
};

RenewalHelpCard.propTypes = {
  description: PropTypes.string.isRequired,
  sx: PropTypes.object,
  title: PropTypes.string.isRequired,
};

export default RenewalHelpCard;
